import React from 'react';
import NavBar from '../components/NavBar';
import Header from '../components/Header';
import Features from '../components/Features';
import MyCard from '../components/MyCard';
import Service from '../components/Service';
import Faq from '../components/Faq';
import PreviousCard from '../components/PreviousCards';
import Catalog from '../components/Catalog';
import Footer from '../components/Footer';
import Line from '../components/Line';
import WorkExperience from '../components/WorkExperience';
import Paiement from '../components/Paiement';
import Site from '../components/Site';

const Home = () => {
  return (
     <>
     <NavBar />
     <MyCard />
     <Line />
     <Service />
     <Line />
     <Paiement />
     <Line />
     <Site />
     <Line />
     <Catalog />
     <Line />
     <PreviousCard />
     <Line />
     <WorkExperience />
     <Line />
     <Features />
     <Line />
     <Faq />
     <Footer />
     </>
  );
};

export default Home;
